/* global lama */
($ => {
  const lamaSearch = document.querySelectorAll('.lama-search');
  let request;

  // This is going to be set to FALSE when using the buil-in LOAD MORE button.
  let clearContainer = true;

  if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  /**
   * Close all the custom dropdowns
   */
  const closeDropdowns = () => {
    const items = document.querySelectorAll('.lama-dropdown');

    items.forEach(item => item.classList.remove('visible'));
  };

  /**
   * Get all the data from the serialized form and "append" all the filters
   * to the URL, with the exception of the one starting with `lama-`.
   */
  const updateUrl = formData => {
    const values = formData.split('&');
    const urlData = [];
    let queryUrl = '';

    /**
     * Only the keys not starting with lama- and not empty, please :)
     */
    values.forEach(value => {
      if (value.indexOf('lama-') === -1 && value.indexOf('query-') === -1) {
        const [key, v] = value.split('=');

        if (v.length > 0) {
          urlData.push(value);
        }
      }

      // get the pages base url with no pagination or filtering.
      if (value.indexOf('lama-base_url') === 0) {
        queryUrl = decodeURIComponent(value.split('=')[1]);
      }
    });

    /**
     * Update the URL without refresh
     */
    const parameters = urlData.join('&');
    const qmark = parameters.length ? '?' : '';
    const url = `${queryUrl}${qmark}${parameters}`;

    window.history.pushState({}, '', url);
  };

  /**
   * Perform the ajax request.
   *
   * @param {string} data serialized data.
   */
  const doAjax = ($form, formData, $container) => {
    if (request) {
      request.abort();
    }

    $('body').trigger('lamaStart', [$form, $container]);

    const data = {
      action: 'nine3_lama',
      nonce: lama.nonce,
      lamaFilter: true,
      lamaName: $form.attr('name'),
      params: formData,
    };

    $form.removeClass('lama--done');

    request = $.ajax({
      type: 'POST',
      url: lama.ajaxurl,
      data,
      success: response => {
        const $items = $(response);

        if ($items.length) {
          $items.not('.lama-posts-found').addClass('loaded');

          $container.append($items);

          // There are more elements to load?
          const foundPosts = parseInt($container.find('lama-found').html(), 10);
          // const lamaPostsCount = parseInt($container.find('lama-posts-count').html(), 10);
          const lamaOffset = parseInt($container.find('lama-offset').html(), 10);

          $form.find('input[name="query-offset"]').val(lamaOffset);
          if (lamaOffset >= foundPosts) {
            $form.addClass('lama-more--none');
          } else {
            $form.removeClass('lama-more--none');
          }

          /**
           * Update the label for founded posts, if any.
           */
          const $postsFound = $form.find('.lama-posts-found__label');
          if ($postsFound.length) {
            $postsFound.html($container.find('lama-posts-found-label').html());
          }

          // Don't need the custom <lama-*> tags anymore
          $container.find('lama-found').remove();
          $container.find('lama-offset').remove();
          $container.find('lama-posts-count').remove();
          $container.find('lama-posts-found-label').remove();

          $form.removeClass('lama--ajax');
          $form.addClass('lama--done');
        } else {
          // No more items.
          $form.addClass('lama-more--none');
        }

        clearContainer = true;

        $('body').trigger('lamaDone', [$container, $items]);
      },
    });
  };

  /**
   * Prevent the form submission and do the ajax request.
   */
  const submitForm = (form, event = undefined) => {
    if (!form.classList.contains('lama')) {
      return true;
    }

    if (event) {
      event.preventDefault();
    }

    // The ajax process is started
    const $form = $(form);

    /**
     * Update the "lama-more" property:
     *
     * 0 => no load more (so ignore the offset parameter)
     * 1 => load more
     */
    $form.find('input[name="lama-more"]').val(clearContainer ? 0 : 1);

    const formData = $form.serialize();
    const $container = $form.find('.lama-container');

    $form.addClass('lama--ajax');

    /**
     * Update the URL with the filters selected
     */
    updateUrl(formData);

    /**
     * Remove all the children
     */
    if (clearContainer) {
      $container.empty();
    }

    /**
     * Perform the ajax request
     */
    doAjax($form, formData, $container);

    return false;
  };

  /**
   * Reset the fields within the form.
   */
  const clearForm = form => {
    const elements = form.elements;
    form.reset();

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const fieldType = element.type.toLowerCase();
      switch (fieldType) {
        case 'text':
        case 'password':
        case 'textarea':
        case 'hidden':
          element.value = '';
          break;
        case 'radio':
        case 'checkbox':
          if (element.checked) {
            element.checked = false;
          }
          break;
        case 'select':
        case 'select-one':
        case 'select-multi':
          element.selectedIndex = 0;
          break;
        default:
          break;
      }
    }
  };

  /**
   * Collapse the dropdown when clicking outside it.
   */
  document.addEventListener('click', e => {
    let target = e.target;
    let parent = target.parentNode;

    // Am I clicking any of the <span> element inside the "lama-dropdown__selected" button?
    if (parent.classList.contains('lama-dropdown__selected')) {
      target = parent;
      parent = target.parentNode;
    }

    // Check if the current element is already open
    const isOpen = parent.classList.contains('visible');

    // Close all the dropdowns (included this one)
    closeDropdowns();

    // If the element was open before calling closeDropdowns don't need to do anything else!
    if (isOpen) {
      return;
    }

    // Am I clicking on the custom select button?
    if (target.classList.contains('lama-dropdown__selected')) {
      /**
       * Toggle the list height
       */
      const list = target.nextSibling.children[0];
      target.nextSibling.style.setProperty('--max-height', `${list.clientHeight}px`);

      parent.classList.add('visible');
      e.stopPropagation();
      // Am I clicking on the custom select single item?
    } else if (target.classList.contains('lama-dropdown__list__button')) {
      /**
       * When submitting the form with AJAX, need to update the <select>
       * as the button itself is not part of the value got from
       * $form.serialize();
       */
      const name = target.getAttribute('name');
      const form = target.closest('form');
      const select = form.querySelector(`select[data-filter="${name}"]`);

      // The span "selected" label
      const lama = target.closest('.lama-dropdown');
      const label = lama.querySelector('.lama-dropdown__selected__label');

      select.value = target.value;

      // Update the <span> label
      label.innerHTML = target.innerHTML;
      // Am I clicking on the custom checkbox / radio filters?
    } else if (
      target.classList.contains('lama-filter') &&
      target.type &&
      ['checkbox', 'radio'].indexOf(target.type) >= 0
    ) {
      /**
       * Checkboxes and radio boxes will automatically trigger the form submit
       */
      const form = target.closest('form');
      submitForm(form);
    }
  });

  /**
   * Search input trigger load on change
   */
  lamaSearch.forEach(input => {
    const form = input.closest('form.lama');

    const debounce = parseInt(input.getAttribute('data-debounce'), 10) || 200;
    let timeout = null;

    input.addEventListener('input', () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        submitForm(form);
      }, debounce);
    });
  });

  /**
   * When clicking on the "LOAD MORE" button we have to keep the items in the container
   */
  $('body').on('click', '.lama-submit', () => {
    clearContainer = false;
  });

  /**
   * Submit the form using AJAX
   */
  document.addEventListener('submit', event => {
    submitForm(event.target, event);
  });

  /**
   * Reset the form when using <input type="reset"> button
   */
  document.addEventListener('reset', event => {
    clearForm(event.target);
  });
})(jQuery);
